module.exports = __webpack_public_path__ + "img/victoria.3fe1932c.svg";